var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrease31Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5521 35.5336C44.988 35.018 44.1125 35.0595 43.5968 35.6236L39.9978 39.5652V7.24307C39.9978 6.28794 39.2226 5.51276 38.2675 5.51276H19.3068C18.3516 5.51276 17.5765 6.28794 17.5765 7.24307V18.189H3.46062V1.73031C3.46062 0.775178 2.68544 0 1.73031 0C0.775178 0 0 0.775178 0 1.73031V19.9193C0 20.8744 0.775178 21.6496 1.73031 21.6496H19.3068C20.2619 21.6496 21.0371 20.8744 21.0371 19.9193V8.97338H36.5406V39.8421L32.2599 35.7758C31.7062 35.2498 30.8306 35.2706 30.3011 35.8243C29.7751 36.378 29.7959 37.2535 30.3496 37.7795L36.686 43.801C36.9559 44.4101 37.5615 44.8323 38.2675 44.8323C38.2813 44.8323 38.2917 44.8323 38.3021 44.8288C38.309 44.8288 38.3159 44.8288 38.3229 44.8288C38.4163 44.8288 38.5097 44.8184 38.5997 44.8011C38.6274 44.7942 38.6551 44.7838 38.6828 44.7769C38.7451 44.7596 38.8073 44.7458 38.8662 44.7181C39.278 44.5658 39.6137 44.2613 39.8075 43.8702L45.6386 37.4854C46.1542 36.9213 46.1127 36.0458 45.5486 35.5301L45.5521 35.5336Z",
    fill: "#24C062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease31Plus);
export default __webpack_public_path__ + "static/media/decrease31plus.1673a30e22bd7adeb17408a5504fefbd.svg";
export { ForwardRef as ReactComponent };